export class CompleteRegister {
  constructor(authApiClient) {
    this.authApiClient = authApiClient;
  }

  execute(payload) {
    return this.authApiClient.completeRegister(payload);
  }
}
